import { gql } from "@apollo/client";

export const LIST_SESSIONS = gql`
  query ListSessions {
    listMySessions {
      id
      createdAt
      isCurrentSession
      userAgent
      userIp
    }
  }
`;

export const END_SESSION = gql`
  mutation EndSession($id: String!) {
    endSession(id: $id)
  }
`;

export const END_ALL_MY_OTHER_SESSIONS = gql`
  mutation EndAllMyOtherSessions {
    endAllMyOtherSessions
  }
`;
